import { Helmet } from 'react-helmet-async';
import rightmessage from "../feature/rightmessage.jpg";
import bulktxt from "../feature/bulktxt.webp";
import naturallanguage from "../feature/naturallanguage.jpg";
import righttime from "../feature/righttime.jpg";
import customercapture0 from "../feature/customercapture0.webp";
import FeatureSection from './FeatureSection';
import FeaturesBottom from './FeaturesBottom';
import FeatureHeroSection from './FeatureHeroSection';
import main from "../feature/bannerA.webp";
import ContactIcon from './ContactIcon';

function RevenueAgent(){

    return ( 
        <>
            <Helmet>
                <title>Kadhr — Repeat Revenue Agent</title>
                <meta
                name="description"
                content="Kadhr’s Repeat Revenue Agent prevents customer drop-off by automatically detecting revenue at risk and keeping customers coming back — without manual follow-ups."
                />
            </Helmet>
            <main className="mtopcon0 ovrflwhdn" id="up">
                <ContactIcon/>
                <div className="row">                    
                    <FeatureHeroSection
                        title="Understand your customers — and act on it automatically"
                        description="Kadhr doesn’t just store customer data — it understands it in a data-driven way. Customers expect personalized experiences as standard, so Kadhr identifies who to reach, what to say, and when — then acts automatically."
                        image={main}
                    />
                    <div className="col-12 text-center mt-5 pt-6indx0" id='features'>
                        <FeatureSection
                            title="Customer Memory"
                            description="Kadhr remembers what every customer buys — building a living profile of what each customer buys, likes, and repeats."
                            image={customercapture0}
                            reverse
                        />

                        <FeatureSection
                            title="Behavior Understanding & Reorder Timing"
                            description={
                                <> Kadhr estimates when customers are likely to need a product again based on real buying patterns, not guesswork.
                                <br /><br />
                                 We identify patterns — like repeat buyers, one-time customers, and drop-off risk — automatically.
                                </>
                            }
                            image={righttime}
                        />

                        <FeatureSection
                            title="AI Powered Relationship Messaging & Natural Re-engagement"
                            description={
                                <>
                                    Customers receive friendly, relevant messages — not spam — right when they’re ready to buy again.
                                    <br /><br />
                                    Kadhr turns insight into action — sending natural, personalized messages that feel human, not automated.
                                </>
                            }
                            image={naturallanguage}
                            reverse
                        />

                        <FeatureSection title="Bulk, But Smart" description="Reach many customers at once — while keeping each message relevant." image={bulktxt} />

                        <FeatureSection
                            title="Repeat Revenue Tracking"
                            description="See how many customers Kadhr brings back — and how much revenue it recovers."
                            image={rightmessage}
                        />
                    </div> 
                

                    <FeaturesBottom/>


                </div>
            </main>
        </>
    );
}

export default RevenueAgent;
